import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 382 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M40.741 130.014a77.623 77.623 0 0130.975-69.771l49.063-36.448a77.624 77.624 0 0170.022-11.596l92.124 29.582c36.101 11.592 58.545 47.57 53.082 85.091l-12.282 84.355a77.626 77.626 0 01-42.659 58.521l-63.695 31.211a77.627 77.627 0 01-53.615 5.439l-56.117-14.531c-31.576-8.177-54.671-35.22-57.806-67.686l-9.092-94.167z",
      fill: "url(#pillow-search_svg__paint0_linear_737_64869)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M63.89 43.275a.97.97 0 110 1.94h-3.88v3.882a.97.97 0 11-1.941 0v-3.881h-3.881a.97.97 0 010-1.94h3.88v-3.882a.97.97 0 011.942 0v3.881h3.88zM123.661 318.064a.971.971 0 010 1.941h-3.881v3.881a.97.97 0 11-1.941 0v-3.881h-3.881a.97.97 0 110-1.941h3.881v-3.881a.97.97 0 011.941 0v3.881h3.881z",
      fill: "#FAB800",
      opacity: 0.7
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M312.287 183.775a.97.97 0 110 1.94h-3.881v3.882a.97.97 0 11-1.94 0v-3.882h-3.882a.97.97 0 010-1.94h3.882v-3.881a.97.97 0 111.94 0v3.881h3.881zM237.768 265.28a.971.971 0 010 1.941h-3.881v3.881a.97.97 0 11-1.94 0v-3.881h-3.882a.97.97 0 010-1.941h3.882v-3.881a.97.97 0 111.94 0v3.881h3.881zM87.178 127.193a.97.97 0 010 1.941h-3.881v3.881a.97.97 0 11-1.94 0v-3.881h-3.882a.97.97 0 010-1.941h3.881v-3.881a.97.97 0 011.94 0v3.881h3.882z",
      fill: "#FAB800",
      opacity: 0.8
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M274.834 63.651a7.762 7.762 0 017.762 7.763 7.762 7.762 0 11-7.762-7.763zm0 3.105a4.658 4.658 0 100 9.316 4.658 4.658 0 000-9.316zM158.398 2.329a7.762 7.762 0 017.762 7.762 7.762 7.762 0 11-15.524 0 7.762 7.762 0 017.762-7.762zm0 3.105a4.657 4.657 0 100 9.314 4.657 4.657 0 000-9.314zM26.437 260.816a7.763 7.763 0 110 15.526 7.763 7.763 0 010-15.526zm0 3.105a4.658 4.658 0 10.002 9.316 4.658 4.658 0 00-.002-9.316z",
      fill: "#FAB800",
      opacity: 0.7
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M343.143 251.501a7.763 7.763 0 11-.001 15.525 7.763 7.763 0 01.001-15.525zm0 3.105a4.658 4.658 0 10.002 9.316 4.658 4.658 0 00-.002-9.316z",
      fill: "#FAB800",
      opacity: 0.4
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M279.42 154.598c-.908 13.633-5.298 46.956-15.6 71.179 1.118 5.122 2.293 16.046-1.951 18.762-4.244 2.716-14.146-4.46-18.567-8.387-24.591.847-84.73-3.986-128.556-30.093-5.617 1.167-18.753 3.65-22.255-.32-2.884-3.271 3.083-11.878 7.327-15.905-7.326-47.782 3.249-48.124 15.148-69.119-1.233-3.868-2.889-13.106.348-19.113 1.849-3.433 14.017 3.952 19.003 9.682 16.554-2.962 55.246-3.545 97.823 11.758 0 0-27.169 18.234-38.424 26.384 2.279-.869-7.375 10.479 7.374 14.749 13.06-2.261 36.846-7.771 52.008-11.379 1.368-.326 2.667-.144 3.88 0h2.718c4.552-1.097 7.374-3.37 7.374-3.37-1.517-.433 17.979-4.657 17.979-4.657-1.261 3.776-3.448 7.853-5.629 9.829z",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M232.139 123.043c-42.576-15.304-81.269-14.721-97.822-11.759-4.986-5.73-17.154-13.114-19.003-9.682-3.237 6.007-1.581 15.245-.348 19.113 0 0-26.819 24.054-15.148 69.119-4.244 4.028-10.212 12.634-7.327 15.905 3.502 3.971 16.638 1.488 22.255.32 43.826 26.108 103.965 30.94 128.556 30.093 4.42 3.928 14.323 11.103 18.567 8.387 4.244-2.716 3.069-13.639 1.951-18.762 10.302-24.223 14.692-57.545 15.6-71.179 2.181-1.975 4.368-6.052 5.629-9.829",
      stroke: "#2d6ded",
      strokeWidth: 1.552
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M113.152 206.641c.644-1.073.999-1.698.999-1.698 44.225 17.57 92.275 22.507 114.992 22.503 0 0 16.537 1.574 24.797-11.492 9.433-17.044 16.08-48.046 19.382-68.774l.348-.082c1.52-.358 12.17-2.329 12.17-2.329-1.255 3.808-3.464 7.946-5.667 9.942-.907 13.633-5.298 46.955-15.6 71.179 1.118 5.122 2.293 16.045-1.951 18.761-4.244 2.716-14.146-4.459-18.567-8.386-24.591.847-84.73-3.986-128.556-30.094-.681.142-1.474.303-2.347.47z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M158.397 185.521c0 17.149 13.901 31.05 31.049 31.05h5.434",
      stroke: "#2d6ded",
      strokeWidth: 1.552,
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ e.createElement("mask", { id: "pillow-search_svg__a", fill: "#fff" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M157.091 167.042c.131.92 1.408.783 1.711-.095 1.567-4.541 5.765-8.12 11.107-8.882 5.341-.761 10.372 1.501 13.147 5.423.305.432 1.01.241.935-.282-.994-6.967-7.821-11.756-15.249-10.697-7.428 1.059-12.645 7.566-11.651 14.533z"
    }
  )),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M157.091 167.042c.131.92 1.408.783 1.711-.095 1.567-4.541 5.765-8.12 11.107-8.882 5.341-.761 10.372 1.501 13.147 5.423.305.432 1.01.241.935-.282-.994-6.967-7.821-11.756-15.249-10.697-7.428 1.059-12.645 7.566-11.651 14.533z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M183.056 163.488l1.901-1.345-1.901 1.345zm-24.254 3.459l-2.201-.76 2.201.76zm2.201.76c1.275-3.693 4.733-6.694 9.235-7.336l-.658-4.611c-6.182.882-11.119 5.037-12.979 10.427l4.402 1.52zm9.235-7.336c4.501-.642 8.661 1.273 10.917 4.462l3.802-2.69c-3.293-4.655-9.195-7.265-15.377-6.383l.658 4.611zm-1.167-5.557c6.296-.898 11.822 3.164 12.615 8.721l4.61-.658c-1.194-8.377-9.323-13.894-17.883-12.673l.658 4.61zm-9.675 11.9c-.792-5.557 3.378-11.002 9.675-11.9l-.658-4.61c-8.56 1.22-14.822 8.79-13.627 17.167l4.61-.657zm21.759-1.881a2.885 2.885 0 003.156 1.11c1.139-.329 2.212-1.477 1.985-3.066l-4.61.658a1.888 1.888 0 01.337-1.355c.283-.398.663-.616.998-.712a1.772 1.772 0 011.936.675l-3.802 2.69zm-24.554 1.354a1.252 1.252 0 011.1-.84c.259-.02.649.027 1.03.301.418.301.617.727.665 1.066l-4.61.657a3.03 3.03 0 001.225 2.058c.667.48 1.42.611 2.051.561a3.404 3.404 0 002.941-2.283l-4.402-1.52z",
      fill: "#2d6ded",
      mask: "url(#pillow-search_svg__a)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      d: "M199.332 164.57l53.423-12.293-10.775-3.245-47.101 12.283 4.453 3.255zM268.4 148.805l73.455-18.767-9.373-4.822-76.183 20.875 12.101 2.714z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M317.434 98.776c3.784 10.209 8.861 18.8 13.983 24.442 2.563 2.822 5.109 4.876 7.479 6.038 2.369 1.162 4.494 1.404 6.296.736 1.803-.668 3.257-2.237 4.296-4.661 1.04-2.427 1.633-5.644 1.737-9.455.207-7.617-1.541-17.442-5.325-27.65-3.784-10.209-8.862-18.8-13.984-24.442-2.562-2.823-5.108-4.876-7.478-6.039-2.369-1.16-4.494-1.403-6.296-.735-1.803.668-3.257 2.237-4.296 4.661-1.04 2.427-1.633 5.644-1.737 9.455-.207 7.617 1.541 17.442 5.325 27.65z",
      fill: "#fff",
      stroke: "#2d6ded",
      strokeWidth: 1.552
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M322.51 97.155c3.072 8.288 6.959 15.348 10.737 20.063 1.891 2.361 3.728 4.099 5.39 5.118 1.671 1.026 3.044 1.256 4.109.861 1.066-.395 1.957-1.464 2.556-3.331.596-1.857.856-4.372.752-7.395-.207-6.038-1.861-13.926-4.933-22.214-3.072-8.289-6.959-15.349-10.737-20.064-1.892-2.36-3.728-4.098-5.39-5.118-1.671-1.025-3.044-1.256-4.11-.86-1.065.394-1.956 1.463-2.556 3.331-.595 1.856-.856 4.371-.752 7.394.208 6.039 1.862 13.926 4.934 22.215z",
      fill: "#fff",
      stroke: "#2d6ded",
      strokeWidth: 1.552
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M191.979 150.872l46.186-32.214M316.747 57.723l-65.204 52.008",
      stroke: "#2d6ded",
      strokeWidth: 1.552,
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ e.createElement("mask", { id: "pillow-search_svg__b", fill: "#fff" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M269.045 148.281c-12.433 0-22.511-10.078-22.511-22.511a22.428 22.428 0 016.113-15.422c.51-.543.104-1.456-.63-1.33-10.607 1.818-18.68 11.059-18.68 22.186 0 12.432 10.079 22.511 22.511 22.511 5.081 0 9.769-1.683 13.536-4.522.393-.297.153-.912-.339-.912z"
    }
  )),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M269.045 148.281c-12.433 0-22.511-10.078-22.511-22.511a22.428 22.428 0 016.113-15.422c.51-.543.104-1.456-.63-1.33-10.607 1.818-18.68 11.059-18.68 22.186 0 12.432 10.079 22.511 22.511 22.511 5.081 0 9.769-1.683 13.536-4.522.393-.297.153-.912-.339-.912z",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M269.384 149.193l-.934-1.24.934 1.24zm-16.737-38.845l-1.131-1.064 1.131 1.064zm-4.561 15.422c0 11.575 9.383 20.959 20.959 20.959v3.105c-13.29 0-24.064-10.774-24.064-24.064h3.105zm5.691-14.358a20.88 20.88 0 00-5.691 14.358h-3.105a23.983 23.983 0 016.535-16.486l2.261 2.128zm-1.497-.864c-9.875 1.693-17.39 10.298-17.39 20.656h-3.105c0-11.895 8.63-21.772 19.97-23.717l.525 3.061zm-17.39 20.656c0 11.575 9.383 20.958 20.958 20.958v3.105c-13.289 0-24.063-10.773-24.063-24.063h3.105zm20.958 20.958c4.733 0 9.094-1.566 12.602-4.209l1.868 2.479a23.963 23.963 0 01-14.47 4.835v-3.105zm12.602-4.209a1.073 1.073 0 00-.355 1.224c.134.352.489.657.95.657v-3.105c.952 0 1.674.612 1.953 1.345.286.753.137 1.743-.68 2.358l-1.868-2.479zm-16.934-38.669a.729.729 0 00-.127.798.851.851 0 00.891.466l-.525-3.061c1.15-.197 2.07.464 2.453 1.295.37.802.297 1.856-.431 2.63l-2.261-2.128z",
      fill: "#2d6ded",
      mask: "url(#pillow-search_svg__b)"
    }
  ),
  /* @__PURE__ */ e.createElement("mask", { id: "pillow-search_svg__c", fill: "#fff" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M202.357 164.195a9.12 9.12 0 01-7.509-14.297c.424-.613-.018-1.51-.725-1.275a9.126 9.126 0 00-6.232 8.654 9.12 9.12 0 009.12 9.12 9.08 9.08 0 005.484-1.832c.159-.12.062-.37-.138-.37z"
    }
  )),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M202.495 164.565l-.934-1.24.934 1.24zm-7.705-9.49a7.567 7.567 0 007.567 7.568v3.105c-5.894 0-10.672-4.778-10.672-10.673h3.105zm1.336-4.294a7.519 7.519 0 00-1.336 4.294h-3.105c0-2.248.697-4.337 1.886-6.059l2.555 1.765zm-1.512-.685a7.572 7.572 0 00-5.17 7.181h-3.105c0-4.716 3.057-8.713 7.293-10.126l.982 2.945zm-5.17 7.181a7.567 7.567 0 007.567 7.567v3.105c-5.894 0-10.672-4.778-10.672-10.672h3.105zm7.567 7.567c1.71 0 3.283-.565 4.55-1.519l1.868 2.479a10.626 10.626 0 01-6.418 2.145v-3.105zm4.55-1.519a1.358 1.358 0 00-.452 1.561c.177.466.641.862 1.248.862v-3.105c.807 0 1.419.521 1.655 1.141a1.744 1.744 0 01-.583 2.02l-1.868-2.479zm-7.99-14.309a.626.626 0 00-.029.661c.063.117.19.274.413.375.244.11.488.101.659.044l-.982-2.945a2.184 2.184 0 011.601.071c.491.222.835.597 1.044.986a2.48 2.48 0 01-.151 2.573l-2.555-1.765z",
      fill: "#2d6ded",
      mask: "url(#pillow-search_svg__c)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M196.636 165.62l57.053-12.808M343.733 130.301l-77.236 19.018",
      stroke: "#2d6ded",
      strokeWidth: 1.552,
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M337.854 122.562c4.557-3.335 3.755-17.729-2.072-33.45-4.489-12.11-10.726-21.68-15.928-25.236.281-.205.582-.369.904-.488 5.541-2.054 15.048 9.81 21.234 26.5 6.186 16.69 6.709 31.885 1.168 33.938-1.521.564-3.339.08-5.306-1.264z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M227.093 142.721l3.881-5.046M226.705 144.662l-2.717-2.329M189.446 216.571h6.598c17.148 0 31.049-13.901 31.049-31.05v-50.174",
      stroke: "#2d6ded",
      strokeWidth: 1.552,
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M200.291 174.654c-4.35 7.565-13.182 6.062-17.055 4.365 2.769 7.565 8.404 9.699 10.876 9.214 3.46-.679 5.355-9.457 6.179-13.579z",
      fill: "#2d6ded",
      stroke: "#2d6ded",
      strokeWidth: 1.364,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M313.944 235.43c-3.62-19.083 22.662-17.88 30.821-35.876.391-.982 1.826 10.302.866 14.407-.159.665-6.608 4.74-6.798 5.384-.158.548 5.415.116 5.236.654-4.36 12.582-19.295 23.063-30.642 16.033",
      stroke: "#2d6ded",
      strokeWidth: 1.552,
      strokeMiterlimit: 10
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M327.746 216.317c-8.28 4.889-15.608 9.217-13.583 19.89l-.517.601c.531.33 1.071.621 1.617.875-.354-8.296 6.062-13.028 13.177-18.276 6.554-4.834 13.701-10.106 16.697-19.004-.06-.144-.113-.176-.154-.073-3.595 7.932-10.712 12.134-17.237 15.987z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      stroke: "#2d6ded",
      strokeWidth: 1.552,
      strokeLinecap: "round",
      d: "M305.282 242.446l19.75-14.264"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M67.038 143.496c4.212-22.201-26.364-20.801-35.856-41.738-.455-1.142-2.125 11.985-1.007 16.761.184.774 7.687 5.514 7.908 6.263.184.639-6.3.135-6.091.761 5.071 14.638 22.447 26.832 35.648 18.653",
      stroke: "#2d6ded",
      strokeWidth: 1.806,
      strokeMiterlimit: 10
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M67.126 141.842c-.06.817-.173 1.668-.342 2.557l.602.7c-13.2 8.178-30.577-4.015-35.648-18.653-.104-.311 1.45-.343 3.014-.375 1.58-.033 3.17-.065 3.076-.386-.108-.367-1.962-1.691-3.848-3.037-1.966-1.403-3.966-2.831-4.06-3.226-1.117-4.777.553-17.904 1.007-16.762a27.817 27.817 0 002.224 3.994c-.022.869.003 1.651.087 2.301.062.461.36 1.352.646 2.202.24.718.471 1.407.543 1.786.061.339.028 1.059-.006 1.793-.037.793-.075 1.602.006 1.963 3.561 15.06 18.603 28.994 32.7 25.143z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      stroke: "#2d6ded",
      strokeWidth: 1.806,
      strokeLinecap: "round",
      d: "M77.117 151.658l-22.978-16.594"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M105.613 192.896c4.916-9.056 15.137-36.095 16.689-71.802M106.777 189.791s-13.972-39.588 15.137-65.592",
      stroke: "#2d6ded",
      strokeWidth: 1.552,
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      d: "M106.636 189.791s-13.972-39.588 15.137-65.592c0 9.315-1.411 35.707-15.137 65.592z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      stroke: "#2d6ded",
      strokeWidth: 1.552,
      d: "M111.893 135.845l8.539.776"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      stroke: "#2d6ded",
      strokeWidth: 1.552,
      strokeLinecap: "round",
      d: "M108.814 143.714l10.105 1.347M105.73 151.505l12.441 2.073M104.96 159.276l11.667 2.059M104.215 170.191l8.579 1.98M105.002 180.299l4.704 1.176"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M63.89 43.275a.97.97 0 110 1.94h-3.88v3.882a.97.97 0 11-1.941 0v-3.881h-3.881a.97.97 0 010-1.94h3.88v-3.882a.97.97 0 011.942 0v3.881h3.88zM123.661 318.064a.971.971 0 010 1.941h-3.881v3.881a.97.97 0 11-1.941 0v-3.881h-3.881a.97.97 0 110-1.941h3.881v-3.881a.97.97 0 011.941 0v3.881h3.881z",
      fill: "#FAB800",
      opacity: 0.7
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M312.287 183.775a.97.97 0 110 1.94h-3.881v3.882a.97.97 0 11-1.94 0v-3.882h-3.882a.97.97 0 010-1.94h3.882v-3.881a.97.97 0 111.94 0v3.881h3.881zM237.768 265.28a.971.971 0 010 1.941h-3.881v3.881a.97.97 0 11-1.94 0v-3.881h-3.882a.97.97 0 010-1.941h3.882v-3.881a.97.97 0 111.94 0v3.881h3.881zM87.178 127.193a.97.97 0 010 1.941h-3.881v3.881a.97.97 0 11-1.94 0v-3.881h-3.882a.97.97 0 010-1.941h3.881v-3.881a.97.97 0 011.94 0v3.881h3.882z",
      fill: "#FAB800",
      opacity: 0.8
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M274.834 63.651a7.762 7.762 0 017.762 7.763 7.762 7.762 0 11-7.762-7.763zm0 3.105a4.658 4.658 0 100 9.316 4.658 4.658 0 000-9.316zM158.398 2.329a7.762 7.762 0 017.762 7.762 7.762 7.762 0 11-15.524 0 7.762 7.762 0 017.762-7.762zm0 3.105a4.657 4.657 0 100 9.314 4.657 4.657 0 000-9.314zM26.437 260.816a7.763 7.763 0 110 15.526 7.763 7.763 0 010-15.526zm0 3.105a4.658 4.658 0 10.002 9.316 4.658 4.658 0 00-.002-9.316z",
      fill: "#FAB800",
      opacity: 0.7
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M343.143 251.501a7.763 7.763 0 11-.001 15.525 7.763 7.763 0 01.001-15.525zm0 3.105a4.658 4.658 0 10.002 9.316 4.658 4.658 0 00-.002-9.316z",
      fill: "#FAB800",
      opacity: 0.4
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M279.42 154.598c-.908 13.633-5.298 46.956-15.6 71.179 1.118 5.122 2.293 16.046-1.951 18.762-4.244 2.716-14.146-4.46-18.567-8.387-24.591.847-84.73-3.986-128.556-30.093-5.617 1.167-18.753 3.65-22.255-.32-2.884-3.271 3.083-11.878 7.327-15.905-7.326-47.782 3.249-48.124 15.148-69.119-1.233-3.868-2.889-13.106.348-19.113 1.849-3.433 14.017 3.952 19.003 9.682 16.554-2.962 55.246-3.545 97.823 11.758 0 0-27.169 18.234-38.424 26.384 2.279-.869-7.375 10.479 7.374 14.749 13.06-2.261 36.846-7.771 52.008-11.379 1.368-.326 2.667-.144 3.88 0h2.718c4.552-1.097 7.374-3.37 7.374-3.37-1.517-.433 17.979-4.657 17.979-4.657-1.261 3.776-3.448 7.853-5.629 9.829z",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M232.139 123.043c-42.576-15.304-81.269-14.721-97.822-11.759-4.986-5.73-17.154-13.114-19.003-9.682-3.237 6.007-1.581 15.245-.348 19.113 0 0-26.819 24.054-15.148 69.119-4.244 4.028-10.212 12.634-7.327 15.905 3.502 3.971 16.638 1.488 22.255.32 43.826 26.108 103.965 30.94 128.556 30.093 4.42 3.928 14.323 11.103 18.567 8.387 4.244-2.716 3.069-13.639 1.951-18.762 10.302-24.223 14.692-57.545 15.6-71.179 2.181-1.975 4.368-6.052 5.629-9.829",
      stroke: "#2d6ded",
      strokeWidth: 1.552
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M113.152 206.641c.644-1.073.999-1.698.999-1.698 44.225 17.57 92.275 22.507 114.992 22.503 0 0 16.537 1.574 24.797-11.492 9.433-17.044 16.08-48.046 19.382-68.774l.348-.082c1.52-.358 12.17-2.329 12.17-2.329-1.255 3.808-3.464 7.946-5.667 9.942-.907 13.633-5.298 46.955-15.6 71.179 1.118 5.122 2.293 16.045-1.951 18.761-4.244 2.716-14.146-4.459-18.567-8.386-24.591.847-84.73-3.986-128.556-30.094-.681.142-1.474.303-2.347.47z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M158.397 185.521c0 17.149 13.901 31.05 31.049 31.05h5.434",
      stroke: "#2d6ded",
      strokeWidth: 1.552,
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ e.createElement("mask", { id: "pillow-search_svg__d", fill: "#fff" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M157.091 167.042c.131.92 1.408.783 1.711-.095 1.567-4.541 5.765-8.12 11.107-8.882 5.341-.761 10.372 1.501 13.147 5.423.305.432 1.01.241.935-.282-.994-6.967-7.821-11.756-15.249-10.697-7.428 1.059-12.645 7.566-11.651 14.533z"
    }
  )),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M157.091 167.042c.131.92 1.408.783 1.711-.095 1.567-4.541 5.765-8.12 11.107-8.882 5.341-.761 10.372 1.501 13.147 5.423.305.432 1.01.241.935-.282-.994-6.967-7.821-11.756-15.249-10.697-7.428 1.059-12.645 7.566-11.651 14.533z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M183.056 163.488l1.901-1.345-1.901 1.345zm-24.254 3.459l-2.201-.76 2.201.76zm2.201.76c1.275-3.693 4.733-6.694 9.235-7.336l-.658-4.611c-6.182.882-11.119 5.037-12.979 10.427l4.402 1.52zm9.235-7.336c4.501-.642 8.661 1.273 10.917 4.462l3.802-2.69c-3.293-4.655-9.195-7.265-15.377-6.383l.658 4.611zm-1.167-5.557c6.296-.898 11.822 3.164 12.615 8.721l4.61-.658c-1.194-8.377-9.323-13.894-17.883-12.673l.658 4.61zm-9.675 11.9c-.792-5.557 3.378-11.002 9.675-11.9l-.658-4.61c-8.56 1.22-14.822 8.79-13.627 17.167l4.61-.657zm21.759-1.881a2.885 2.885 0 003.156 1.11c1.139-.329 2.212-1.477 1.985-3.066l-4.61.658a1.888 1.888 0 01.337-1.355c.283-.398.663-.616.998-.712a1.772 1.772 0 011.936.675l-3.802 2.69zm-24.554 1.354a1.252 1.252 0 011.1-.84c.259-.02.649.027 1.03.301.418.301.617.727.665 1.066l-4.61.657a3.03 3.03 0 001.225 2.058c.667.48 1.42.611 2.051.561a3.404 3.404 0 002.941-2.283l-4.402-1.52z",
      fill: "#2d6ded",
      mask: "url(#pillow-search_svg__d)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      d: "M199.332 164.57l53.423-12.293-10.775-3.245-47.101 12.283 4.453 3.255zM268.4 148.805l73.455-18.767-9.373-4.822-76.183 20.875 12.101 2.714z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M317.434 98.776c3.784 10.209 8.861 18.8 13.983 24.442 2.563 2.822 5.109 4.876 7.479 6.038 2.369 1.162 4.494 1.404 6.296.736 1.803-.668 3.257-2.237 4.296-4.661 1.04-2.427 1.633-5.644 1.737-9.455.207-7.617-1.541-17.442-5.325-27.65-3.784-10.209-8.862-18.8-13.984-24.442-2.562-2.823-5.108-4.876-7.478-6.039-2.369-1.16-4.494-1.403-6.296-.735-1.803.668-3.257 2.237-4.296 4.661-1.04 2.427-1.633 5.644-1.737 9.455-.207 7.617 1.541 17.442 5.325 27.65z",
      fill: "#fff",
      stroke: "#2d6ded",
      strokeWidth: 1.552
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M322.51 97.155c3.072 8.288 6.959 15.348 10.737 20.063 1.891 2.361 3.728 4.099 5.39 5.118 1.671 1.026 3.044 1.256 4.109.861 1.066-.395 1.957-1.464 2.556-3.331.596-1.857.856-4.372.752-7.395-.207-6.038-1.861-13.926-4.933-22.214-3.072-8.289-6.959-15.349-10.737-20.064-1.892-2.36-3.728-4.098-5.39-5.118-1.671-1.025-3.044-1.256-4.11-.86-1.065.394-1.956 1.463-2.556 3.331-.595 1.856-.856 4.371-.752 7.394.208 6.039 1.862 13.926 4.934 22.215z",
      fill: "#fff",
      stroke: "#2d6ded",
      strokeWidth: 1.552
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M191.979 150.872l46.186-32.214M316.747 57.723l-65.204 52.008",
      stroke: "#2d6ded",
      strokeWidth: 1.552,
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ e.createElement("mask", { id: "pillow-search_svg__e", fill: "#fff" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M269.045 148.281c-12.433 0-22.511-10.078-22.511-22.511a22.428 22.428 0 016.113-15.422c.51-.543.104-1.456-.63-1.33-10.607 1.818-18.68 11.059-18.68 22.186 0 12.432 10.079 22.511 22.511 22.511 5.081 0 9.769-1.683 13.536-4.522.393-.297.153-.912-.339-.912z"
    }
  )),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M269.045 148.281c-12.433 0-22.511-10.078-22.511-22.511a22.428 22.428 0 016.113-15.422c.51-.543.104-1.456-.63-1.33-10.607 1.818-18.68 11.059-18.68 22.186 0 12.432 10.079 22.511 22.511 22.511 5.081 0 9.769-1.683 13.536-4.522.393-.297.153-.912-.339-.912z",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M269.384 149.193l-.934-1.24.934 1.24zm-16.737-38.845l-1.131-1.064 1.131 1.064zm-4.561 15.422c0 11.575 9.383 20.959 20.959 20.959v3.105c-13.29 0-24.064-10.774-24.064-24.064h3.105zm5.691-14.358a20.88 20.88 0 00-5.691 14.358h-3.105a23.983 23.983 0 016.535-16.486l2.261 2.128zm-1.497-.864c-9.875 1.693-17.39 10.298-17.39 20.656h-3.105c0-11.895 8.63-21.772 19.97-23.717l.525 3.061zm-17.39 20.656c0 11.575 9.383 20.958 20.958 20.958v3.105c-13.289 0-24.063-10.773-24.063-24.063h3.105zm20.958 20.958c4.733 0 9.094-1.566 12.602-4.209l1.868 2.479a23.963 23.963 0 01-14.47 4.835v-3.105zm12.602-4.209a1.073 1.073 0 00-.355 1.224c.134.352.489.657.95.657v-3.105c.952 0 1.674.612 1.953 1.345.286.753.137 1.743-.68 2.358l-1.868-2.479zm-16.934-38.669a.729.729 0 00-.127.798.851.851 0 00.891.466l-.525-3.061c1.15-.197 2.07.464 2.453 1.295.37.802.297 1.856-.431 2.63l-2.261-2.128z",
      fill: "#2d6ded",
      mask: "url(#pillow-search_svg__e)"
    }
  ),
  /* @__PURE__ */ e.createElement("mask", { id: "pillow-search_svg__f", fill: "#fff" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M202.357 164.195a9.12 9.12 0 01-7.509-14.297c.424-.613-.018-1.51-.725-1.275a9.126 9.126 0 00-6.232 8.654 9.12 9.12 0 009.12 9.12 9.08 9.08 0 005.484-1.832c.159-.12.062-.37-.138-.37z"
    }
  )),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M202.495 164.565l-.934-1.24.934 1.24zm-7.705-9.49a7.567 7.567 0 007.567 7.568v3.105c-5.894 0-10.672-4.778-10.672-10.673h3.105zm1.336-4.294a7.519 7.519 0 00-1.336 4.294h-3.105c0-2.248.697-4.337 1.886-6.059l2.555 1.765zm-1.512-.685a7.572 7.572 0 00-5.17 7.181h-3.105c0-4.716 3.057-8.713 7.293-10.126l.982 2.945zm-5.17 7.181a7.567 7.567 0 007.567 7.567v3.105c-5.894 0-10.672-4.778-10.672-10.672h3.105zm7.567 7.567c1.71 0 3.283-.565 4.55-1.519l1.868 2.479a10.626 10.626 0 01-6.418 2.145v-3.105zm4.55-1.519a1.358 1.358 0 00-.452 1.561c.177.466.641.862 1.248.862v-3.105c.807 0 1.419.521 1.655 1.141a1.744 1.744 0 01-.583 2.02l-1.868-2.479zm-7.99-14.309a.626.626 0 00-.029.661c.063.117.19.274.413.375.244.11.488.101.659.044l-.982-2.945a2.184 2.184 0 011.601.071c.491.222.835.597 1.044.986a2.48 2.48 0 01-.151 2.573l-2.555-1.765z",
      fill: "#2d6ded",
      mask: "url(#pillow-search_svg__f)"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M196.636 165.62l57.053-12.808M343.733 130.301l-77.236 19.018",
      stroke: "#2d6ded",
      strokeWidth: 1.552,
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M337.854 122.562c4.557-3.335 3.755-17.729-2.072-33.45-4.489-12.11-10.726-21.68-15.928-25.236.281-.205.582-.369.904-.488 5.541-2.054 15.048 9.81 21.234 26.5 6.186 16.69 6.709 31.885 1.168 33.938-1.521.564-3.339.08-5.306-1.264z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M227.093 142.721l3.881-5.046M226.705 144.662l-2.717-2.329M189.446 216.571h6.598c17.148 0 31.049-13.901 31.049-31.05v-50.174",
      stroke: "#2d6ded",
      strokeWidth: 1.552,
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M200.291 174.654c-4.35 7.565-13.182 6.062-17.055 4.365 2.769 7.565 8.404 9.699 10.876 9.214 3.46-.679 5.355-9.457 6.179-13.579z",
      fill: "#2d6ded",
      stroke: "#2d6ded",
      strokeWidth: 1.364,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M313.944 235.43c-3.62-19.083 22.662-17.88 30.821-35.876.391-.982 1.826 10.302.866 14.407-.159.665-6.608 4.74-6.798 5.384-.158.548 5.415.116 5.236.654-4.36 12.582-19.295 23.063-30.642 16.033",
      stroke: "#2d6ded",
      strokeWidth: 1.552,
      strokeMiterlimit: 10
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M327.746 216.317c-8.28 4.889-15.608 9.217-13.583 19.89l-.517.601c.531.33 1.071.621 1.617.875-.354-8.296 6.062-13.028 13.177-18.276 6.554-4.834 13.701-10.106 16.697-19.004-.06-.144-.113-.176-.154-.073-3.595 7.932-10.712 12.134-17.237 15.987z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      stroke: "#2d6ded",
      strokeWidth: 1.552,
      strokeLinecap: "round",
      d: "M305.282 242.446l19.75-14.264"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M67.038 143.496c4.212-22.201-26.364-20.801-35.856-41.738-.455-1.142-2.125 11.985-1.007 16.761.184.774 7.687 5.514 7.908 6.263.184.639-6.3.135-6.091.761 5.071 14.638 22.447 26.832 35.648 18.653",
      stroke: "#2d6ded",
      strokeWidth: 1.806,
      strokeMiterlimit: 10
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M67.126 141.842c-.06.817-.173 1.668-.342 2.557l.602.7c-13.2 8.178-30.577-4.015-35.648-18.653-.104-.311 1.45-.343 3.014-.375 1.58-.033 3.17-.065 3.076-.386-.108-.367-1.962-1.691-3.848-3.037-1.966-1.403-3.966-2.831-4.06-3.226-1.117-4.777.553-17.904 1.007-16.762a27.817 27.817 0 002.224 3.994c-.022.869.003 1.651.087 2.301.062.461.36 1.352.646 2.202.24.718.471 1.407.543 1.786.061.339.028 1.059-.006 1.793-.037.793-.075 1.602.006 1.963 3.561 15.06 18.603 28.994 32.7 25.143z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      stroke: "#2d6ded",
      strokeWidth: 1.806,
      strokeLinecap: "round",
      d: "M77.117 151.658l-22.978-16.594"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M105.613 192.896c4.916-9.056 15.137-36.095 16.689-71.802M106.777 189.791s-13.972-39.588 15.137-65.592",
      stroke: "#2d6ded",
      strokeWidth: 1.552,
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      opacity: 0.2,
      d: "M106.636 189.791s-13.972-39.588 15.137-65.592c0 9.315-1.411 35.707-15.137 65.592z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      stroke: "#2d6ded",
      strokeWidth: 1.552,
      d: "M111.893 135.845l8.539.776"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      stroke: "#2d6ded",
      strokeWidth: 1.552,
      strokeLinecap: "round",
      d: "M108.814 143.714l10.105 1.347M105.73 151.505l12.441 2.073M104.96 159.276l11.667 2.059M104.215 170.191l8.579 1.98M105.002 180.299l4.704 1.176"
    }
  ),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
    "linearGradient",
    {
      id: "pillow-search_svg__paint0_linear_737_64869",
      x1: 191,
      y1: 328.81,
      x2: 190.581,
      y2: 13.037,
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ e.createElement("stop", { stopColor: "#2d6ded", stopOpacity: 0.5 }),
    /* @__PURE__ */ e.createElement("stop", { offset: 1, stopColor: "#2d6ded", stopOpacity: 0.03 })
  ))
), d = t;
export {
  d as default
};
